import React from "react";
import "./css/headersub.css";

const HeaderSub = ({ onOpenEnrollment }) => {
  return (
    <section className="header-sub d-none d-lg-block">
      <div className="container">
        <div className="header-sub__inner">
          <div className="header-sub__content">
            <div className="header-sub__title">Bạn cần tư vấn nhanh?</div>
            <div className="header-sub__desc">
              Để lại thông tin, đội ngũ hỗ trợ sẽ liên hệ sớm nhất.
            </div>
          </div>

          <button
            type="button"
            className="header-sub__btn"
            onClick={onOpenEnrollment}
          >
            Liên hệ tư vấn
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeaderSub;
